// import React from "react";

// const NotFound: React.FC = () => {
//   return (
//     <div className="notfound-page">
//       {/* Left Section */}
//       <div className="notfound-left">
//         <div className="left-content">
//           <div className="badge">
//             <span className="maple">🍁</span>
//             <span>CANADIAN SMALL BUSINESS PAYROLL</span>
//           </div>

//           <h1>
//             Oops! <br />
//             Page Not Found
//           </h1>

//           <p className="subtitle">
//             Error <strong>404</strong>
//           </p>

//           <p className="description">
//             The page you’re looking for doesn’t exist or may have been moved.
//             Don’t worry — managing payroll should still be easy.
//           </p>

//           <div className="actions">
//             <a href="/" className="primary-btn">
//               Go to Dashboard
//             </a>
//             <a href="/login" className="secondary-btn">
//               Back to Login
//             </a>
//           </div>

//           <p className="support">
//             Need help? <a href="#">Contact Support</a>
//           </p>
//         </div>
//       </div>

//       {/* Right Section */}
//       <div className="notfound-right">
//         <div className="error-box">
//           <div className="logo">
//             <span className="logo-box">▢</span>
//             <span className="logo-text">paycub</span>
//           </div>

//           <div className="error-code">404</div>
//           <p className="error-text">Page Not Found</p>

//           <div className="illustration">
//             <div className="circle" />
//             <div className="circle small" />
//           </div>
//         </div>

//         <footer>
//           Copyright © PayCub 2025. <a href="#">Terms of Use</a>
//         </footer>
//       </div>
//     </div>
//   );
// };

// export default NotFound;

import { Button } from "primereact/button";
import React from "react";
import { useNavigate } from "react-router-dom";
import AppBreadcrumb from "../CustomeBreadcrumb/AppBreadcrumb";

const NotFound: React.FC = () => {
  // get user data from local storage
  const rawUserData = localStorage.getItem("user_data");
  let userData: any = null;
  userData = rawUserData ? JSON.parse(rawUserData) : null;

  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  // redirect according to role
  const redirectByRole = (role: string) => {
    switch (role) {
      case "Admin":
        return "/admin-dashboard";

      case "User":
        return "/user-dashboard";

      case "Client":
        return "/client-dashboard";

      case "Employee":
        return "/employee-dashboard";

      default:
        return "/dashboard";
    }
  };

  return (
    <>
      <div className="notfound-page">
        <div className="notfound-container">
          <div className="logo mb-0">
            <span className="logo-bo">
              {" "}
              <div className="flex gap-2 mb-0 justify-content-center align-items-center logo-container">
                <img
                  src="\assets\images\Nexawage_new_logo.png"
                  className="login-logo"
                  style={{ width: "80px", height: "80px" }}
                  alt="login-logo"
                />
                <h2 className="m-0" style={{ color: "#41486b" }}>
                  Nexawage Payroll
                </h2>
              </div>
            </span>
            {/* <span className="logo-text">Nexawage</span> */}
          </div>

          <div className="error-code">404</div>
          <h1>Page Not Found</h1>

          <p className="description">
            Sorry, the page you are looking for doesn’t exist or has been moved.
            Let’s get you back on track.
          </p>

          <div className="actions">
            {/* <a href="/" className="primary-btn">
            Go to Dashboard
          </a> */}

            <a
              className="primary-btn"
              onClick={() => {
                const role = userData?.roles?.role_name;
                navigate(redirectByRole(role));
              }}
            >
              Go To Dashboard
            </a>
            <a
              className="secondary-btn"
              onClick={() => {
                localStorage.clear();
                navigate("/login");
              }}
            >
              Back to Login
            </a>
          </div>

          <footer>{`Copyright © Nexawage Payroll ${currentYear}.`}</footer>
        </div>
      </div>
    </>
  );
};

export default NotFound;
